import classNames from 'classnames'
import React, { ReactNode, useState } from 'react'
import { observable, action } from 'mobx'
import { observer } from 'mobx-react-lite'
import useInterval from 'use-interval'
import { t } from '@lingui/macro'

import { isIE } from 'shared/helpers'
import { LinkBox } from '../link/Link'
import IconX from '../icon/IconX'

import './Notifications.less'
import { ListItem, UnorderedList } from '@chakra-ui/react'
import { brandColors } from 'front-end/../shared/basicPalette'

export type NotificationTypes = 'WARNING' | 'ERROR' | 'INFO' | 'OTHER'

export interface INotification {
  content: ReactNode
  type: NotificationTypes
  active: boolean
}
export const notificationsQueue: INotification[] = observable([])

export const Notifications: React.FC<{}> = observer(() => {
  if (isIE) {
    // hackfix for alerts in IE. For some very strange reason in IE observer doesn't react to changes in the notificationsQueue. TODO figure out a better fix
    const [length, updateLength] = useState<number>(0)

    useInterval(() => {
      if (length !== notificationsQueue.length) {
        updateLength(notificationsQueue.length)
      }
    }, 150)
  }

  const [currentNotif] = notificationsQueue

  let notifElement: ReactNode | null = null
  if (currentNotif) {
    notifElement = (
      <ListItem
        className={`notification ${currentNotif.type}`}
        backgroundColor={getBcgColor(currentNotif.type)}
      >
        <div className="content">{currentNotif.content}</div>
        <LinkBox
          tabIndex={1}
          onClick={() => {
            currentNotif.active = false
            notificationsQueue.shift()
          }}
          className="close"
          aria-label={t`Close`}
        >
          <IconX w="28px" aria-hidden="true" />
        </LinkBox>
      </ListItem>
    )
  }
  return (
    <UnorderedList className="notifications">
      <div
        className={classNames('fade', { in: currentNotif?.active })}
        aria-live="polite"
        aria-atomic="true"
        aria-hidden="false"
      >
        {notifElement}
      </div>
    </UnorderedList>
  )
})

const showNotificationOfType = (type: NotificationTypes) => {
  return action('showNotification', (content: ReactNode, delay = 5000) => {
    const newNotif = observable({ type, active: true, content })
    notificationsQueue.push(newNotif)

    setTimeout(() => {
      newNotif.active = false
      setTimeout(() => {
        // let the animation finish
        notificationsQueue.shift()
      }, 500)
    }, delay)
  })
}

export const notification = {
  warning: showNotificationOfType('WARNING'),
  error: showNotificationOfType('ERROR'),
  info: showNotificationOfType('INFO')
}

const getBcgColor = (type: NotificationTypes) => {
  switch (type) {
    case 'WARNING':
      return brandColors.yellow[300]
    case 'ERROR':
      return brandColors.red[300]
    case 'INFO':
      return brandColors.green[300]
    case 'OTHER':
      return brandColors.grey[300]
  }
}

export default Notifications
